/**
 * Blog Page Block - Frontend JavaScript
 * Handles AJAX filtering and pagination for blog posts
 */
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        const blogPage = document.querySelector('.blog-page');
        if (!blogPage) return;

        const tabs = blogPage.querySelectorAll('.blog-page__tab');
        const postsContainer = blogPage.querySelector('#blog-posts-container');
        const paginationContainer = blogPage.querySelector('.blog-page__pagination');
        const paginationNumbers = blogPage.querySelector('#pagination-numbers');
        const prevButton = blogPage.querySelector('.blog-page__pagination-button--prev');
        const nextButton = blogPage.querySelector('.blog-page__pagination-button--next');

        // Get AJAX URL from data attribute
        const ajaxUrl = blogPage.getAttribute('data-ajax-url') || '/wp-admin/admin-ajax.php';

        let currentCategory = 'all';
        let currentPage = 1;
        let totalPages = parseInt(paginationContainer?.getAttribute('data-total-pages') || '1', 10);
        let isLoading = false;

        // Tab switching
        tabs.forEach(function(tab) {
            tab.addEventListener('click', function() {
                if (isLoading) return;

                const categoryId = this.getAttribute('data-category-id');

                // Update active tab
                tabs.forEach(function(t) {
                    t.classList.remove('blog-page__tab--active');
                    t.setAttribute('aria-selected', 'false');
                });
                this.classList.add('blog-page__tab--active');
                this.setAttribute('aria-selected', 'true');

                // Reset to page 1 when changing category
                currentCategory = categoryId;
                currentPage = 1;
                fetchPosts();
            });
        });

        // Pagination - Previous button
        if (prevButton) {
            prevButton.addEventListener('click', function() {
                if (currentPage > 1 && !isLoading) {
                    currentPage--;
                    fetchPosts();
                }
            });
        }

        // Pagination - Next button
        if (nextButton) {
            nextButton.addEventListener('click', function() {
                if (currentPage < totalPages && !isLoading) {
                    currentPage++;
                    fetchPosts();
                }
            });
        }

        // Pagination - Number buttons
        if (paginationNumbers) {
            paginationNumbers.addEventListener('click', function(e) {
                if (e.target.classList.contains('blog-page__pagination-number') && !isLoading) {
                    const page = parseInt(e.target.getAttribute('data-page'), 10);
                    if (page && page !== currentPage) {
                        currentPage = page;
                        fetchPosts();
                    }
                }
            });
        }

        function fetchPosts() {
            if (isLoading) return;
            isLoading = true;

            // Add loading state
            postsContainer.style.opacity = '0.5';
            postsContainer.style.pointerEvents = 'none';

            const params = new URLSearchParams({
                action: 'filter_blog_posts',
                category: currentCategory,
                paged: currentPage,
                posts_per_page: 9,
            });

            fetch(ajaxUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: params.toString(),
            })
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                if (data.success) {
                    postsContainer.innerHTML = data.data.html;
                    totalPages = data.data.total_pages;
                    updatePagination();

                    // Scroll to top of posts
                    blogPage.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                    console.error('Error fetching posts:', data);
                }
            })
            .catch(function(error) {
                console.error('AJAX error:', error);
            })
            .finally(function() {
                isLoading = false;
                postsContainer.style.opacity = '1';
                postsContainer.style.pointerEvents = 'auto';
            });
        }

        function updatePagination() {
            if (!paginationContainer || !paginationNumbers) return;

            // Update pagination container data
            paginationContainer.setAttribute('data-current-page', currentPage);
            paginationContainer.setAttribute('data-total-pages', totalPages);

            // Update prev/next buttons
            if (prevButton) {
                prevButton.disabled = currentPage === 1;
            }
            if (nextButton) {
                nextButton.disabled = currentPage === totalPages;
            }

            // Update pagination numbers
            var numbersHTML = '';
            var maxVisible = 10;

            if (totalPages <= maxVisible) {
                // Show all pages
                for (var i = 1; i <= totalPages; i++) {
                    numbersHTML += createPageButton(i);
                }
            } else {
                // Show with ellipsis
                if (currentPage <= 4) {
                    for (var i = 1; i <= 5; i++) {
                        numbersHTML += createPageButton(i);
                    }
                    numbersHTML += '<span class="blog-page__pagination-ellipsis text-text-tertiary-(600)">...</span>';
                    numbersHTML += createPageButton(totalPages);
                } else if (currentPage >= totalPages - 3) {
                    numbersHTML += createPageButton(1);
                    numbersHTML += '<span class="blog-page__pagination-ellipsis text-text-tertiary-(600)">...</span>';
                    for (var i = totalPages - 4; i <= totalPages; i++) {
                        numbersHTML += createPageButton(i);
                    }
                } else {
                    numbersHTML += createPageButton(1);
                    numbersHTML += '<span class="blog-page__pagination-ellipsis text-text-tertiary-(600)">...</span>';
                    for (var i = currentPage - 1; i <= currentPage + 1; i++) {
                        numbersHTML += createPageButton(i);
                    }
                    numbersHTML += '<span class="blog-page__pagination-ellipsis text-text-tertiary-(600)">...</span>';
                    numbersHTML += createPageButton(totalPages);
                }
            }

            paginationNumbers.innerHTML = numbersHTML;

            // Hide pagination if only one page
            if (totalPages <= 1) {
                paginationContainer.style.display = 'none';
            } else {
                paginationContainer.style.display = 'flex';
            }
        }

        function createPageButton(page) {
            var isActive = page === currentPage;
            var classes = isActive
                ? 'blog-page__pagination-number blog-page__pagination-number--active text-text-primary-(900)'
                : 'blog-page__pagination-number text-text-tertiary-(600)';
            var ariaCurrent = isActive ? 'page' : 'false';

            return '<button class="' + classes + '" data-page="' + page + '" aria-label="Page ' + page + '" aria-current="' + ariaCurrent + '">' + page + '</button>';
        }
    });
})();
